/*import React from 'react';
import './logo.css'
import { Link } from "react-router-dom";

const Logo = () => {
    

    return (
        <div className='logoContainer'>
            
            <img className='logo' src={brand}/>
        </div>
    );
};

export default Logo;*/
import brand from '../logoMod.png'

import React from "react";
import "./logo.css";

const Logo = () => {
  return (
    <div className="logoContainer">
      <img className="logo" src={brand} alt="Logo de la aplicación" />
    </div>
  );
};

export default Logo;
